import { getApi, postApi } from "../apiCall";

export const getUserAdmin = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/analyst/get/company/dashboard`;
  return postApi(url);
};

export const getUserAdminCompanyProfile = (token, id) => {
  let url = `${process.env.REACT_APP_API_URL}/view/profile?userId=${id}`;
  return getApi(url);
};

export const getUserAdminDocument = (token, id) => {
  let url = `${process.env.REACT_APP_API_URL}/analyst/getDocumentsByCompany?companyId=${id}`;
  return getApi(url);
};
